'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bluebird = require('bluebird');

var _bignumber = require('bignumber.js');

var _isAddress = require('../utilities/isAddress');

var _isAddress2 = _interopRequireDefault(_isAddress);

var _modalify = require('../utilities/modalify');

var _modalify2 = _interopRequireDefault(_modalify);

var _AuthorizeToken = require('../components/modals/AuthorizeToken');

var _AuthorizeToken2 = _interopRequireDefault(_AuthorizeToken);

var _AuthorizeTokenNoInputs = require('../components/modals/AuthorizeTokenNoInputs');

var _AuthorizeTokenNoInputs2 = _interopRequireDefault(_AuthorizeTokenNoInputs);

var _safeToBn = require('../utilities/safeToBn');

var _safeToBn2 = _interopRequireDefault(_safeToBn);

var _tokenUtilities = require('../utilities/tokenUtilities');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assertAddressIsValid = function assertAddressIsValid(address) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Contract';

  if (!(0, _isAddress2.default)(address)) {
    throw new Error(name + ' address is an invalid ethereum address');
  }
};

var DynamicTokenContract = function () {
  function DynamicTokenContract(web3Eth) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, DynamicTokenContract);

    this.web3Eth = web3Eth;
    this.contracts = {};
    this.appName = config.appName;
    this.etherscanAddressUrl = config.etherscanAddressUrl;
    this.authorizeGasLimit = config.authorizeGasLimit || 70000;
    this.mintGasLimit = config.mintGasLimit || 70000;

    this.getContract = this.getContract.bind(this);

    this.fetchSymbol = this.fetchSymbol.bind(this);
    this.fetchName = this.fetchName.bind(this);
    this.fetchDecimals = this.fetchDecimals.bind(this);
    this.fetchBalance = this.fetchBalance.bind(this);
    this.fetchAllowance = this.fetchAllowance.bind(this);
    this.authorizeTransaction = this.authorizeTransaction.bind(this);
    this.mintTransaction = this.mintTransaction.bind(this);
  }

  /**
   * Get the token contract object for a given address.
   * Save the contract in a list for easy re-use.
   *
   * @param {String} contractAddress
   *
   * @returns {Object}
   */


  _createClass(DynamicTokenContract, [{
    key: 'getContract',
    value: function getContract(contractAddress) {
      if (this.contracts[contractAddress]) {
        return this.contracts[contractAddress];
      }
      var contract = new this.web3Eth.Contract(_constants.DYNAMIC_TOKEN_CONTRACT_ABI);
      contract.options.address = contractAddress;
      this.contracts[contractAddress] = contract;
      return contract;
    }

    /**
     * Fetch the symbol from a given token contract.
     *
     * @param {String} contractAddress
     *
     * @returns {Promise<String>}
     */

  }, {
    key: 'fetchSymbol',
    value: function fetchSymbol(contractAddress) {
      assertAddressIsValid(contractAddress);
      var contract = this.getContract(contractAddress);
      return contract.methods.symbol().call();
    }

    /**
     * Fetch the name from a given token contract.
     *
     * @param {String} contractAddress
     *
     * @returns {Promise<String>}
     */

  }, {
    key: 'fetchName',
    value: function fetchName(contractAddress) {
      assertAddressIsValid(contractAddress);
      var contract = this.getContract(contractAddress);
      return contract.methods.name().call();
    }

    /**
     * Fetch the decimals from a given token contract.
     *
     * @param {String} contractAddress
     *
     * @returns {Promise<Number>}
     */

  }, {
    key: 'fetchDecimals',
    value: function fetchDecimals(contractAddress) {
      assertAddressIsValid(contractAddress);
      var contract = this.getContract(contractAddress);
      return contract.methods.decimals().call().then(function (decimals) {
        return parseInt(decimals, 10);
      });
    }

    /**
     * Fetch token data for a list of token addresses.
     *
     * Token data consists of symbol, name, decimals, address.
     *
     * @param {String[]} tokenAddresses
     *
     * @returns {Promise<Object[]>}
     */

  }, {
    key: 'fetchTokenData',
    value: function fetchTokenData(tokenAddresses) {
      var _this = this;

      return (0, _bluebird.map)(tokenAddresses, function (tokenAddress) {
        assertAddressIsValid(tokenAddress, 'Token');
        return (0, _bluebird.props)({
          symbol: _this.fetchSymbol(tokenAddress),
          name: _this.fetchName(tokenAddress),
          decimals: _this.fetchDecimals(tokenAddress),
          address: tokenAddress
        });
      });
    }

    /**
     * Fetch the token balance for address from a given token contract.
     *
     * @param {String} address
     * @param {String} contractAddress
     *
     * @returns {Promise<BN>} tokenWei
     */

  }, {
    key: 'fetchBalance',
    value: function fetchBalance(address, contractAddress) {
      assertAddressIsValid(address, 'Wallet');
      assertAddressIsValid(contractAddress);
      var contract = this.getContract(contractAddress);
      return contract.methods.balanceOf(address).call().then(function (balance) {
        return (0, _safeToBn2.default)(balance);
      });
    }

    /**
     * Fetch the token allowance the owner has given the spender for a given token contract.
     *
     * @param {String} ownerAddress
     * @param {String} spenderAddress
     * @param {String} contractAddress
     *
     * @returns {Promise<BN>} tokenWei
     */

  }, {
    key: 'fetchAllowance',
    value: function fetchAllowance(ownerAddress, spenderAddress, contractAddress) {
      assertAddressIsValid(ownerAddress, 'Owner');
      assertAddressIsValid(spenderAddress, 'Spender');
      assertAddressIsValid(contractAddress);
      var contract = this.getContract(contractAddress);
      return contract.methods.allowance(ownerAddress, spenderAddress).call().then(function (allowance) {
        return (0, _safeToBn2.default)(allowance);
      });
    }

    /**
     * Generate a transaction object for approving a token allowance for the spender from the sender.
     * Pops up a modal to allow the user to choose how much to authorize/approve.
     *
     * @param {String} spenderAddress
     * @param {BN} amount (tokenWei)
     * @param {String} senderAddress
     * @param {String} contractAddress
     * @param {String} tokenSymbol
     * @param {Number} tokenDecimals
     * @param {String} gasPrice (wei)
     * @param {Bool} forPayment?
     * @param {Node} customMessage?
     * @param {Bool} useInputsModal?
     *
     * @returns {Promise<Object>}
     */

  }, {
    key: 'authorizeTransaction',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(spenderAddress, amount, senderAddress, contractAddress, tokenSymbol, tokenDecimals, gasPrice) {
        var forPayment = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
        var customMessage = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
        var useInputsModal = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : true;
        var contract, component, modal, authorizeAmount, tokenEth;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                assertAddressIsValid(spenderAddress, 'Spender');
                assertAddressIsValid(senderAddress, 'Sender');
                assertAddressIsValid(contractAddress);
                contract = this.getContract(contractAddress);
                component = useInputsModal ? _AuthorizeToken2.default : _AuthorizeTokenNoInputs2.default;
                modal = (0, _modalify2.default)(component);
                _context.next = 8;
                return modal({
                  from: senderAddress,
                  tokenContractAddress: contractAddress,
                  tokenSymbol: tokenSymbol,
                  tokenDecimals: tokenDecimals,
                  amount: amount,
                  gasPrice: gasPrice,
                  appName: this.appName,
                  etherScanAddressUrl: this.etherscanAddressUrl,
                  forPayment: forPayment,
                  closeReturn: null,
                  customMessage: customMessage,
                  useInputsModal: useInputsModal
                });

              case 8:
                authorizeAmount = _context.sent;

                if (!authorizeAmount) {
                  _context.next = 12;
                  break;
                }

                tokenEth = (0, _tokenUtilities.convertFromTokenWei)(authorizeAmount, tokenDecimals);
                return _context.abrupt('return', {
                  transaction: contract.methods.approve(spenderAddress, authorizeAmount),
                  contract: contractAddress,
                  formattedTokenAmount: authorizeAmount.eq(amount) ? tokenEth + ' ' + tokenSymbol : (0, _bignumber.BigNumber)(tokenEth).toExponential(3) + ' ' + tokenSymbol,
                  sendOptions: {
                    from: senderAddress,
                    value: 0,
                    gasPrice: gasPrice,
                    gas: this.authorizeGasLimit
                  },
                  skipConfirmation: true
                });

              case 12:
                return _context.abrupt('return', {});

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function authorizeTransaction(_x6, _x7, _x8, _x9, _x10, _x11, _x12) {
        return _ref.apply(this, arguments);
      }

      return authorizeTransaction;
    }()

    /**
     * Generate a transaction object to mint tokens to the given receiver address.
     *
     * @param {String} receiverAddress
     * @param {BN} amount (tokenWei)
     * @param {String} senderAddress
     * @param {String} contractAddress
     * @param {Node|String} formattedTokenAmount?
     * @param {String} gasPrice (wei)?
     *
     * @returns {Object}
     */

  }, {
    key: 'mintTransaction',
    value: function mintTransaction(receiverAddress, amount, senderAddress, contractAddress) {
      var formattedTokenAmount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var gasPrice = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

      assertAddressIsValid(receiverAddress, 'Recipient');
      assertAddressIsValid(senderAddress, 'Sender');
      assertAddressIsValid(contractAddress);
      var contract = this.getContract(contractAddress);
      return {
        transaction: contract.methods.mint(receiverAddress, amount),
        contract: contractAddress,
        formattedTokenAmount: formattedTokenAmount,
        sendOptions: {
          from: senderAddress,
          value: 0,
          gasPrice: gasPrice,
          gas: this.mintGasLimit
        }
      };
    }
  }]);

  return DynamicTokenContract;
}();

exports.default = DynamicTokenContract;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/DynamicTokenContract.js
// module id = 476
// module chunks = 0